import {StorageHelper} from "../../helpers/storage.helper";

/**
 * Calls `onChange` when ANOTHER tab of this browser changed one of the given keys (the `storage` event never
 * fires in the tab that wrote). The keys are the ones the stores pass to `StorageHelper`; they are compared in
 * the form `StorageHelper.buildKey` writes. `event.key === null` is a `localStorage.clear()`. Returns the
 * unsubscribe function. Shared by the stopwatch state and the gimmicks' look store (feature plan 0072).
 */
export function subscribeKeys(keys: readonly string[], onChange: () => void): () => void {
    const built = keys.map((key) => StorageHelper.buildKey(key));
    const listener = (event: StorageEvent): void => {
        if (event.key === null || built.includes(event.key)) {
            onChange();
        }
    };
    window.addEventListener('storage', listener);
    return () => window.removeEventListener('storage', listener);
}
